import type Owner from '@ember/owner';
import { setOwner } from '@ember/owner';
import { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { FormatUrlParams } from 'frontend-utils/utils/url/format-url';
import { formatUrl } from 'frontend-utils/utils/url/format-url';
import type { DateAggregation } from 'lumen/utils/constants/pi-constant-values';
import getAPIErrorMessage from 'lumen/utils/get-api-error-message';
import SilentTaskError from 'lumen/utils/silent-task-error';

export type ExportConfigResponse = {
  [platform: string]: {
    [ota: string]: {
      extract_date: string;
      from_dates: string[];
      los: number;
      persons: number;
    };
  };
};

type ExportConfigRequestParams = FormatUrlParams & {
  date_aggregation: DateAggregation;
  extract_date: string;
  subscription_id: string;
};

export default class ExportConfigResource {
  @service declare ajax: Services['ajax'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare intl: Services['intl'];

  fetchResourceTask = task(
    { restartable: true },
    async (params: ExportConfigRequestParams) => {
      try {
        return await this.ajax.request<ExportConfigResponse[]>(
          formatUrl(
            '/apigateway/v1/app/parityanalytics/export_configs/',
            params,
            this.ajax.host,
          ),
          {
            method: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
          },
        );
      } catch (error) {
        this.errorTracking.captureException(error);
        throw new SilentTaskError(getAPIErrorMessage(error, this.intl));
      }
    },
  );

  constructor(owner: Owner) {
    setOwner(this, owner);
  }
}
